

const SPLIDE_MODULE_URL = "//www.soapboxsoaps.com/cdn/shop/t/94/assets/splide.esm.js?v=15020223941556135121792768550";

let splideModulePromise = null;



function loadSplide() {

    if (!splideModulePromise) {

        splideModulePromise = import(SPLIDE_MODULE_URL);

    }

    return splideModulePromise;

}



function countSplideSlides(splideRoot) {

    const list = splideRoot.querySelector('.splide__list');

    if (!list) return 0;

    return list.querySelectorAll(':scope > .splide__slide').length;

}



function getMaxPerPage(options) {

    let max = options.perPage || 1;

    const breakpoints = options.breakpoints;

    if (breakpoints && typeof breakpoints === 'object') {

        Object.keys(breakpoints).forEach((key) => {

            const perPage = breakpoints[key] && breakpoints[key].perPage;

            if (typeof perPage === 'number') max = Math.max(max, perPage);

        });

    }

    return max;

}



function shouldUseLoop(options, slideCount) {

    if (options.type !== 'loop') return false;

    if (options.autoWidth) return slideCount >= 3;

    if (slideCount < 2) return false;

    return slideCount > getMaxPerPage(options);

}



function normalizeSplideOptions(options, splideRoot) {

    const slideCount = countSplideSlides(splideRoot);

    if (options.type !== 'loop' || shouldUseLoop(options, slideCount)) return options;

    const normalized = {

        ...options,

        type: 'slide',

        clones: 0,

        cloneStatus: false,

    };

    if (slideCount < 2) {

        normalized.autoplay = false;

        normalized.drag = false;

        normalized.pagination = false;

    }

    splideRoot.setAttribute('data-splide', JSON.stringify(normalized));

    return normalized;

}



function stripSplideClones(splideRoot) {

    splideRoot.querySelectorAll('.splide__slide--clone').forEach((clone) => clone.remove());

}



function hideSingleSlideControls(splideRoot, slideCount) {

    if (slideCount > 1) return;

    const host = splideRoot.closest('splide-slider');

    if (!host) return;

    host.querySelectorAll('.carousel-nav, .swiper-pagination-w').forEach((el) => {

        el.setAttribute('hidden', '');

    });

}



const editorSlideState = new Map();

function getSplideSectionId(host) {

    const sectionEl = host && host.closest('[id^="shopify-section-"]');

    if (!sectionEl || !sectionEl.id) return '';

    return sectionEl.id.replace(/^shopify-section-/, '');

}

function getRealBlockSlides(splideRoot) {

    const list = splideRoot && splideRoot.querySelector('.splide__list');

    if (!list) return [];

    return Array.prototype.filter.call(list.children, (el) => {

        return el.classList.contains('splide__slide') && !el.classList.contains('splide__slide--clone');

    });

}

function rememberEditorSlide(sectionEl, sectionId, blockId) {

    if (!sectionId) return;

    const prev = editorSlideState.get(sectionId) || {};

    const state = {

        blockId: blockId || prev.blockId || null,

        index: typeof prev.index === 'number' ? prev.index : 0,

        fromSlider: !!prev.fromSlider,

    };

    const host = sectionEl && sectionEl.querySelector('splide-slider');

    if (host && host.slider) {

        state.index = host.slider.index || 0;

        state.fromSlider = true;

        if (!state.blockId) {

            const slides = getRealBlockSlides(host.querySelector('.splide') || host);

            const current = slides[state.index];

            if (current && current.dataset.blockId) state.blockId = current.dataset.blockId;

        }

    }

    editorSlideState.set(sectionId, state);

}

function resolveEditorSlideIndex(splideRoot, saved) {

    const slides = getRealBlockSlides(splideRoot);

    if (!slides.length || !saved) return -1;

    if (saved.blockId) {

        const byId = slides.findIndex((slide) => slide.dataset.blockId === saved.blockId);

        if (byId >= 0) return byId;

    }

    if (saved.fromSlider && typeof saved.index === 'number') {

        return Math.min(Math.max(saved.index, 0), slides.length - 1);

    }

    return -1;

}

function applyEditorStartIndex(host, splideRoot, options) {

    if (typeof Shopify === 'undefined' || !Shopify.designMode) return options;

    const saved = editorSlideState.get(getSplideSectionId(host));

    const index = resolveEditorSlideIndex(splideRoot, saved);

    if (index > 0) return { ...options, start: index };

    return options;

}

function restoreEditorSlide(host) {

    if (typeof Shopify === 'undefined' || !Shopify.designMode) return false;

    if (!host || !host.slider) return false;

    const saved = editorSlideState.get(getSplideSectionId(host));

    const index = resolveEditorSlideIndex(host.querySelector('.splide') || host, saved);

    if (index < 0 || host.slider.index === index) return false;

    host.slider.go(index);

    return true;

}



class SplideSlider extends HTMLElement {

    connectedCallback() {

        if (this.dataset.desktopHidden === 'wide' && window.innerWidth > 991) return;

        if (this._initStarted) return;

        this._initStarted = true;



        if (this.shouldMountEager()) {

            this.runLoadAndInit();

        } else {

            this.scheduleLazyInitialize();

        }

    }



    disconnectedCallback() {

        if (this._ioObserver) {

            this._ioObserver.disconnect();

            this._ioObserver = null;

        }

        clearTimeout(this._lazyFallbackTimer);

        if (this.slider) {

            this.slider.destroy(true);

            this.slider = null;

        }

        this._initStarted = false;

        this._loadInFlight = false;

    }



    shouldMountEager() {

        return (

            this.dataset.sliderType === 'sync' ||

            this.dataset.splideEager === 'true'

        );

    }



    scheduleLazyInitialize() {

        const observer = new IntersectionObserver(

            (entries) => {

                for (const entry of entries) {

                    if (entry.isIntersecting) {

                        observer.disconnect();

                        this._ioObserver = null;

                        clearTimeout(this._lazyFallbackTimer);

                        this.runLoadAndInit();

                        break;

                    }

                }

            },

            { root: null, rootMargin: '200px 0px 200px 0px', threshold: 0 }

        );

        observer.observe(this);

        this._ioObserver = observer;



        this._lazyFallbackTimer = setTimeout(() => {
            if (!this.slider && document.visibilityState === 'visible') {
              this.runLoadAndInit();
            }
          }, 4000);

    }



    runLoadAndInit() {

        if (this.dataset.desktopHidden === 'wide' && window.innerWidth > 991) return;

        if (this.slider) return;

        if (this._loadInFlight) return;

        this._loadInFlight = true;



        loadSplide()

            .then((mod) => {

                if (!this.isConnected) return;

                if (this.slider) return;

                const Splide = mod.default;

                this.initialize(Splide);

                if (this.slider) {

                    restoreEditorSlide(this);

                    this.dispatchEvent(

                        new CustomEvent('splide-slider:ready', {

                            bubbles: true,

                            detail: { slider: this.slider },

                        })

                    );

                }

            })

            .catch(() => {

                this._initStarted = false;

            })

            .finally(() => {

                this._loadInFlight = false;

            });

    }



    initialize(Splide) {

        if (this.dataset.desktopHidden === 'wide' && window.innerWidth > 991) return;

        this.slider = null;

        const initializeSplide = (element, options, autoMount = true) => {

            const slideCount = countSplideSlides(element);

            options = normalizeSplideOptions(options, element);

            options = applyEditorStartIndex(this, element, options);

            const splide = new Splide(element, options);

            if (this.dataset.progress === 'true') {

                var bar = splide.root.querySelector('[data-splide-progress]');

                splide.on('mounted move', function () {

                    var end = splide.Components.Controller.getEnd() + 1;

                    var rate = Math.min((splide.index + 1) / end, 1);

                    bar.style.width = String(100 * rate) + '%';

                });

            }



            const mountSplide = () => {

                splide.mount();

                if (!shouldUseLoop(options, slideCount)) {

                    stripSplideClones(element);

                }

                const sliderList = this.querySelectorAll('.splide__list');

                sliderList.forEach((list) => {

                    list.classList.remove('splide-slider--h-scroll');

                });

            };



            if (autoMount) {

                mountSplide();

                hideSingleSlideControls(element, slideCount);

            }



            splide.on('inactive', (slide) => SplideSlider.inactiveEvent(slide));

            if (this.dataset.refPicker === 'true' && window.innerWidth > 991) {

                splide.on('active', (slide) => {

                    SplideSlider.goToReference(slide.index);

                });

            }

            if (this.dataset.destroyedUp) {

                if (window.innerWidth > parseFloat(this.dataset.destroyedUp)) {

                    const slides = this.querySelectorAll('.splide__slide');

                    slides.forEach((slide) => {

                        slide.removeAttribute('tabindex');

                        slide

                            .querySelectorAll('a[tabindex="-1"], button[tabindex="-1"]')

                            .forEach((el) => el.removeAttribute('tabindex'));

                    });

                }

            }

            return {

                splide,

                mount: mountSplide,

            };

        };

        switch (this.dataset.sliderType) {

            case 'sync':

                const mpElem = this.querySelector('[data-main-thumbs]');

                const swElem = this.querySelector('[data-switcher-thumbs]');

                if (!mpElem || !swElem) return;

                const mpOpts = normalizeSplideOptions(

                    JSON.parse(mpElem.getAttribute('data-splide')),

                    mpElem

                );

                const swOpts = normalizeSplideOptions(

                    JSON.parse(swElem.getAttribute('data-splide')),

                    swElem

                );

                const mpInstance = initializeSplide(mpElem, mpOpts, false);

                const swInstance = initializeSplide(swElem, swOpts, false);



                mpInstance.splide.sync(swInstance.splide);

                mpInstance.mount();

                swInstance.mount();

                hideSingleSlideControls(mpElem, countSplideSlides(mpElem));

                hideSingleSlideControls(swElem, countSplideSlides(swElem));



                const galleryPrev = this.querySelector('[data-gallery-prev]');

                const galleryNext = this.querySelector('[data-gallery-next]');

                if (galleryPrev && galleryNext) {

                    const splide = mpInstance.splide;

                    const updateGalleryArrows = () => {

                        galleryPrev.disabled = Math.max(splide.index, 0) === 0;

                        galleryNext.disabled =

                            Math.min(splide.index, splide.length - 1) === splide.length - 1;

                    };

                    galleryPrev.addEventListener('click', () =>

                        splide.go(String.fromCharCode(60))

                    );

                    galleryNext.addEventListener('click', () =>

                        splide.go(String.fromCharCode(62))

                    );

                    updateGalleryArrows();

                    splide.on('move', updateGalleryArrows);

                }

                if (mpElem.classList.contains('product-gallery-main')) {

                    const mainSplide = mpInstance.splide;

                    const track = mpElem.querySelector('.splide__track');

                    // Keep focus within the currently active slide.
                    // Fixes cases where Tab focuses interactive media (e.g., <video>) inside an aria-hidden slide.
                    const focusableSelector = 'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]';
                    const setSlideFocusable = (slideEl, enabled) => {
                        if (!slideEl) return;
                        slideEl.querySelectorAll(focusableSelector).forEach((el) => {
                            // Don't modify disabled controls; and don't clobber explicit tabindex="-1" on purposefully skipped items
                            if (!el || el.disabled) return;
                            const cur = el.getAttribute('tabindex');
                            if (!enabled) {
                                if (cur === '-1') return;
                                if (!el.hasAttribute('data-prev-tabindex')) {
                                    el.setAttribute('data-prev-tabindex', cur == null ? '' : cur);
                                }
                                el.setAttribute('tabindex', '-1');
                            } else {
                                if (el.hasAttribute('data-prev-tabindex')) {
                                    const prev = el.getAttribute('data-prev-tabindex');
                                    el.removeAttribute('data-prev-tabindex');
                                    if (prev === '') el.removeAttribute('tabindex');
                                    else el.setAttribute('tabindex', prev);
                                } else if (el.getAttribute('tabindex') === '-1') {
                                    el.removeAttribute('tabindex');
                                }
                            }
                        });
                    };

                    const syncFocusablesToActive = () => {
                        const slides = mainSplide.Components?.Elements?.slides || [];
                        slides.forEach((slideEl, idx) => setSlideFocusable(slideEl, idx === mainSplide.index));
                    };

                    // If focus lands inside a slide, ensure that slide becomes active
                    mpElem.addEventListener(
                        'focusin',
                        (event) => {
                            const target = event.target;
                            if (!target) return;
                            const slideEl = target.closest && target.closest('.splide__slide');
                            if (!slideEl) return;
                            // Map DOM slide element -> Splide index (getAt expects an index, not an element).
                            const domSlides = mainSplide.Components?.Elements?.slides || [];
                            let idx = domSlides.indexOf(slideEl);
                            if (idx < 0 && slideEl.id) {
                                // Fallback: parse "...-slide07" pattern
                                const m = slideEl.id.match(/-slide(\d+)$/);
                                if (m) idx = parseInt(m[1], 10) - 1;
                            }
                            if (idx < 0 || Number.isNaN(idx)) return;
                            if (idx != null && idx !== mainSplide.index) {
                                mainSplide.go(idx);
                            }
                        },
                        true
                    );

                    mainSplide.on('mounted', syncFocusablesToActive);
                    // Use rAF to wait for Splide to update aria-hidden/classes before toggling tabindex.
                    mainSplide.on('move', () => requestAnimationFrame(syncFocusablesToActive));
                    mainSplide.on('moved', syncFocusablesToActive);
                    mainSplide.on('resized', syncFocusablesToActive);

                    if (track) {

                        const setMainTrackHeight = () => {

                            const slideEl = mainSplide.Components.Slides.getAt(mainSplide.index);

                            const el =

                                slideEl && slideEl.slide

                                    ? slideEl.slide

                                    : mainSplide.Components.Elements.slides[mainSplide.index];

                            if (!el) return;

                            let h = el.offsetHeight;

                            if (!h && el.querySelector('img')) {

                                const img = el.querySelector('img');

                                if (img.naturalWidth && img.naturalHeight)

                                    h =

                                        (el.offsetWidth || img.offsetWidth) *

                                        (img.naturalHeight / img.naturalWidth);

                            }

                            if (h) track.style.setProperty('height', h + 'px', 'important');

                        };

                        const runAfterLayout = (fn) => {

                            requestAnimationFrame(() => requestAnimationFrame(fn));

                        };

                        mainSplide.on('move', () => runAfterLayout(setMainTrackHeight));

                        mainSplide.on('moved', setMainTrackHeight);

                        mainSplide.on('mounted', setMainTrackHeight);

                        mainSplide.on('resized', setMainTrackHeight);

                        runAfterLayout(setMainTrackHeight);

                        setTimeout(setMainTrackHeight, 100);

                        setTimeout(setMainTrackHeight, 400);

                    }

                }

                this.slider = mpInstance.splide;

                break;

            case 'default':

                const elem = this.querySelector('.splide');

                const options = JSON.parse(elem.getAttribute('data-splide'));

                const instance = initializeSplide(elem, options, true);

                const splide = instance.splide;

                if (this.dataset.customArrows === 'true') SplideSlider.customArrows(splide);

                if (this.dataset.customPager === 'true') SplideSlider.customPager(splide);



                const defPrev = this.querySelector('[data-gallery-prev]');

                const defNext = this.querySelector('[data-gallery-next]');

                if (defPrev) defPrev.addEventListener('click', () => splide.go(String.fromCharCode(60)));

                if (defNext) defNext.addEventListener('click', () => splide.go(String.fromCharCode(62)));



                const paginationTarget = this.querySelector('[data-pagination-target]');

                if (paginationTarget) {

                    const movePag = () => {

                        let pag = elem.querySelector('.splide__pagination');

                        if (!pag) pag = paginationTarget.querySelector('.splide__pagination');

                        if (pag) paginationTarget.replaceChildren(pag);

                    };

                    splide.on('mounted', movePag);
                    splide.on('updated', movePag);
                    splide.on('pagination:updated', movePag);
                    movePag();

                }



                this.slider = splide;

                break;

            default:

                break;

        }

    }

    static inactiveEvent(currentSlide) {

        /* window.pauseElementBasedMedia(currentSlide.slide); */

    }



    static goToReference(currentIndex) {

        document

            .querySelector('[data-main-thumbs] .splide__list')

            ?.children[currentIndex]?.scrollIntoView({

                behavior: 'smooth',

                block: 'center',

            });

    }



    static customArrows(splide) {

        function goPrev() {

            splide.go(String.fromCharCode(60));

        }



        function goNext() {

            splide.go(String.fromCharCode(62));

        }



        function addListenersToActiveSlide() {

            const activeSlide = splide.Components.Elements.slides[splide.index];

            const prevButton = activeSlide.querySelector('[data-splide-prev]');

            const nextButton = activeSlide.querySelector('[data-splide-next]');

            if (prevButton) prevButton.addEventListener('click', goPrev);

            if (nextButton) nextButton.addEventListener('click', goNext);

        }



        function removeListenersFromInactiveSlide(slide) {

            const prevButton = slide.querySelector('[data-splide-prev]');

            const nextButton = slide.querySelector('[data-splide-next]');

            if (prevButton) prevButton.removeEventListener('click', goPrev);

            if (nextButton) nextButton.removeEventListener('click', goNext);

        }

        addListenersToActiveSlide();

        splide.on('active', addListenersToActiveSlide);

        splide.on('inactive', (slide) => removeListenersFromInactiveSlide(slide.slide));

    }



    static customPager(splide) {

        function goTo(event) {

            const index = Number(event.target.dataset.splidePager);

            splide.go(index);

        }



        function addListenersToActiveSlide() {

            const activeSlide = splide.Components.Elements.slides[splide.index];

            const buttons = activeSlide.querySelectorAll('[data-splide-pager]');

            buttons.forEach((button) => button.addEventListener('click', goTo));

        }



        function removeListenersFromInactiveSlide(slide) {

            const buttons = slide.querySelectorAll('[data-splide-pager]');

            buttons.forEach((button) => button.removeEventListener('click', goTo));

        }

        addListenersToActiveSlide();

        splide.on('active', addListenersToActiveSlide);

        splide.on('inactive', (slide) => removeListenersFromInactiveSlide(slide.slide));

    }

}

if (!customElements.get('splide-slider')) customElements.define('splide-slider', SplideSlider);



function reinitSplideSlidersInSection(sectionEl) {

    if (!sectionEl) return;

    const reinitHosts = () => {

        sectionEl.querySelectorAll('splide-slider').forEach((host) => {

            if (host.slider) {

                host.slider.destroy(true);

                host.slider = null;

            }

            host._initStarted = false;

            host._loadInFlight = false;

            host.connectedCallback();

        });

    };

    requestAnimationFrame(() => requestAnimationFrame(reinitHosts));

}



if (typeof Shopify !== 'undefined' && Shopify.designMode) {

    document.addEventListener('shopify:section:unload', (event) => {

        rememberEditorSlide(event.target, event.detail && event.detail.sectionId);

    });

    document.addEventListener('shopify:section:load', (event) => {

        reinitSplideSlidersInSection(event.target);

    });

    document.addEventListener('shopify:section:reorder', (event) => {

        reinitSplideSlidersInSection(event.target);

    });

    document.addEventListener('shopify:block:select', (event) => {

        const sectionId = event.detail && event.detail.sectionId;

        const blockId = event.detail && event.detail.blockId;

        const sectionEl = (sectionId && document.getElementById('shopify-section-' + sectionId)) || event.target.closest('[id^="shopify-section-"]');

        rememberEditorSlide(sectionEl, sectionId, blockId);

        if (sectionEl) {

            sectionEl.querySelectorAll('splide-slider').forEach((host) => restoreEditorSlide(host));

        }

        document.querySelectorAll('splide-slider').forEach((host) => {

            if (host.slider && countSplideSlides(host.querySelector('.splide')) < 2) {

                stripSplideClones(host.querySelector('.splide'));

            }

        });

    });

}



class SliderButton extends HTMLElement {

    connectedCallback() {

        const button = this.querySelector('button');

        if (!button) return;

        this.button = button;

        button.addEventListener('click', this.handleClick.bind(this));

        this.initObserver();

    }



    initObserver() {

        const sliderWrapper = document.querySelector(this.dataset.sliderTarget);

        if (!sliderWrapper) return;



        const attach = () => {

            if (this.splide) return true;

            const splide =

                sliderWrapper.slider || sliderWrapper.querySelector('.splide')?.splide;

            if (!splide) return false;

            this.splide = splide;

            splide.on('move', () => this.updateDisabledState());

            splide.on('mounted', () => this.updateDisabledState());

            splide.on('updated', () => this.updateDisabledState());

            this.updateDisabledState();

            return true;

        };



        if (attach()) return;



        sliderWrapper.addEventListener(

            'splide-slider:ready',

            () => {

                attach();

            },

            { once: true }

        );



        let n = 0;

        const max = 120;

        const poll = () => {

            if (attach()) return;

            if (n++ < max) requestAnimationFrame(poll);

        };

        requestAnimationFrame(poll);

    }



    handleClick(event) {

        event.preventDefault();

        const splide = this.splide;

        if (!splide) return;

        if (this.querySelector('.splide__arrow--next')) {

            splide.go(String.fromCharCode(62));

        } else {

            splide.go(String.fromCharCode(60));

        }

    }



    updateDisabledState() {

        const splide = this.splide;

        if (!splide) return;

        const currentIndex = splide.index;

        const slideCount = splide.Components.Slides.getLength();

        const lastIndex = slideCount - 1;

        const isLoop = splide.options.type === 'loop';

        const isNext = this.querySelector('.splide__arrow--next');

        const isPrev = this.querySelector('.splide__arrow--prev');



        if (!isLoop) {

            if (isPrev) {

                this.button.disabled = currentIndex === 0;

            }

            if (isNext) {

                this.button.disabled = currentIndex === lastIndex;

            }

        } else {

            this.button.disabled = false;

        }

    }

}



if (!customElements.get('slider-button')) {

    customElements.define('slider-button', SliderButton);

}



function syncMainAndThumbs(sectionId) {

    const mainEl = document.querySelector(`#main-slider-${sectionId}`);

    const thumbsEl = document.querySelector(`#thumbs-slider-${sectionId}`);

    if (!mainEl || !thumbsEl) return;

    const main = mainEl.slider || mainEl.querySelector('.splide')?.splide;

    const thumbs = thumbsEl.slider || thumbsEl.querySelector('.splide')?.splide;

    if (!main || !thumbs) return;

    if (main._syncedWithThumbs) return;

    main._syncedWithThumbs = true;

    main.sync(thumbs);

    thumbs.sync(main);

    thumbs.on('click', (slide) => {

        main.go(slide.index);

    });

}



document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[id^="main-slider-"]').forEach((mainEl) => {

        const sectionId = mainEl.id.replace('main-slider-', '');

        const thumbsEl = document.querySelector(`#thumbs-slider-${sectionId}`);

        if (!thumbsEl) return;



        const trySync = () => syncMainAndThumbs(sectionId);

        trySync();

        mainEl.addEventListener('splide-slider:ready', trySync, { once: true });

        thumbsEl.addEventListener('splide-slider:ready', trySync, { once: true });



        let n = 0;

        const maxTicks = 40;

        const id = setInterval(() => {

            trySync();

            const main = document.querySelector(`#main-slider-${sectionId}`)?.slider;

            if (main?._syncedWithThumbs || ++n >= maxTicks) clearInterval(id);

        }, 200);

    });

});

